import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../app.service';

@Component({
  selector: 'app-alert-review-routine',
  templateUrl: './alert-review-routine.component.html',
  styleUrls: ['./alert-review-routine.component.scss'],
})
export class AlertReviewRoutineComponent implements OnInit {
  isMobile: boolean
  routineLevel: any

  constructor(public dialogRef: MatDialogRef<AlertReviewRoutineComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private appState: AppState) { 
      this.isMobile = this.appState.get('isMobile')
    }

  ngOnInit() {
    console.log('routine in alert', this.data);
  }
}
